module.exports = __webpack_public_path__ + "img/20200514_152806.beaee666.jpg";